// PieChartSkeleton.jsx
import React from "react";
import SkeletonBox from "./SkeletonBox";

export default function PieChartSkeleton() {
  return (
    <div className="w-full h-[300px] flex flex-col items-center justify-center gap-4 p-4">
      {/* Circular Pie Placeholder */}
      <div className="relative">
        <div
          className="animate-pulse bg-gray-200 rounded-full"
          style={{ width: 180, height: 180 }}
        ></div>

        {/* Inner circle effect */}
        <div className="absolute inset-6 bg-gray-100 rounded-full opacity-60 animate-pulse"></div>
      </div>

      {/* Legend placeholders */}
      <div className="flex flex-wrap justify-center gap-3 mt-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center gap-2">
            <SkeletonBox className="h-3 w-3 rounded-full" />
            <SkeletonBox className="h-3 w-12" />
          </div>
        ))}
      </div>
    </div>
  );
}
